import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';

import { DataOrigins, Vehicle, PurchaseMethods } from '@sm360/widget-commons-vehicle';

import ListingUsed from 'inventory-listing/components/ListingUsed/ListingUsed.jsx';

const {
    resetOptionsAmounts,
    resetPurchaseMethodsFromOriginData,
    resetPurchaseMethodsOptionsFromQuoteItems,
    splitRetailAndIncludedOptions,
} = PurchaseMethods.PurchaseMethodsService;

const { resetVehicleFromShowroomVehicle } = Vehicle.VehicleService;

class ListingNewMediator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            vehicles: [],
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props === nextProps) {
            return;
        }

        if (!nextProps.vehicles || nextProps.vehicles.length === 0) {
            this.setState({ vehicles: [] });
            return;
        }

        const vehicleIds = nextProps.vehicles.map(({ id }) => id);

        PurchaseMethods.DisclaimerAPIService.getGenericDisclaimers().then((disclaimers) => {
            Vehicle.VehicleAPIService.findVehicleByIds(vehicleIds).then((showroomVehicles) => {
                const updatedVehicles = nextProps.vehicles.map((vehicle) => {
                    const showroomVehicle = find(showroomVehicles, { id: vehicle.id });
                    if (!showroomVehicle) {
                        return vehicle;
                    }

                    const newVehicle = resetVehicleFromShowroomVehicle(showroomVehicle);

                    let purchaseMethods = resetPurchaseMethodsFromOriginData(
                        DataOrigins.VEHICLE_PAYMENTS,
                        showroomVehicle.purchaseMethods,
                        nextProps.purchaseMethod,
                        disclaimers
                    );

                    purchaseMethods = splitRetailAndIncludedOptions(
                        resetOptionsAmounts(
                            resetPurchaseMethodsOptionsFromQuoteItems(purchaseMethods, showroomVehicle.items, [])
                        )
                    );

                    return newVehicle
                        .set('purchaseMethods', purchaseMethods)
                        .set('configurationToken', showroomVehicle.configurationToken)
                        .set('flags', vehicle.flags)
                        .set('locked', vehicle.locked)
                        .setIn(['multimedia', 'mainPicture'], vehicle.multimedia.mainPicture)
                        .set('odometer', vehicle.odometer)
                        .set('sellingPrice', vehicle.sellingPrice)
                        .set('stockNumber', vehicle.stockNumber)
                        .set('tagLine', vehicle.tagline)
                        .set('vehicleId', vehicle.vehicleId)
                        .set('vin', vehicle.vin);
                });

                this.setState({ vehicles: updatedVehicles });
            });
        });
    }

    render() {
        return <ListingUsed {...this.props} vehicles={this.state.vehicles} />;
    }
}

ListingNewMediator.defaultProps = {
    vehicles: [],
};

ListingNewMediator.propTypes = {
    purchaseMethod: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    vehicles: PropTypes.arrayOf(
        // eslint-disable-line react/no-unused-prop-types
        PropTypes.instanceOf(Vehicle.VehicleModel) // eslint-disable-line react/no-unused-prop-types
    ),
};

ListingNewMediator.displayName = 'ListingNewMediator';

export default ListingNewMediator;



// WEBPACK FOOTER //
// ./client/src/containers/ListingNew/ListingNewMediator.jsx